export default __webpack_public_path__ + "static/media/photo 7.2431eb34.jpg";